module.exports = __webpack_public_path__ + "static/img/item1.0c53138.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/teacher/item1.png
// module id = ulf8
// module chunks = 63